import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left w-full" }
const _hoisted_2 = { class: "col-span-2 sm:col-span-1" }
const _hoisted_3 = { class: "col-span-2 sm:col-span-1 order-3 sm:order-2 sm:text-center" }
const _hoisted_4 = { class: "col-span-1 text-right order-2 sm:order-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "px-5 bg-brandy inline-block cursor-default"
}

import {
    CustomerDeliveryCheckOutDeliverable,
    HubModel, PickUpCheckOutDeliverable,
} from '@/b2c/shared/api/server-apis';
import BasketDeliverableDialog from '@/b2c/basket/ui/BasketDeliverableDialog.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutChangePickUp',
  props: {
    isOpen: { type: Boolean, default: false },
    deliverable: null,
    hubs: null,
    selectedLabel: { default: '' },
    selectLabel: { default: '' },
    selectedId: { default: '' }
  },
  emits: ['close', 'select'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, deliverable: CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable, hubs: HubModel[], selectedLabel: string, selectLabel: string, selectedId: string }





const labels = useBlockLabels();

const select = (hub: HubModel): void => {
    emit('select', hub);
    close();
};

const close = (): void => {
    emit('close');
};

const isSelected = (hub: HubModel): boolean => {
    return hub.id === props.selectedId;
};

const isSelectable = (status: HubModel): boolean => {
    return !isSelected(status);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasketDeliverableDialog, {
    "is-open": __props.isOpen,
    heading: _unref(labels).pickUpPointDialogHeading,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("dl", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.hubs, (hub) => {
          return (_openBlock(), _createElementBlock("div", {
            key: hub.id,
            class: "grid grid-cols-3 mb-x3"
          }, [
            _createElementVNode("dt", _hoisted_2, _toDisplayString(hub.name), 1),
            _createElementVNode("dd", _hoisted_3, _toDisplayString(hub.street) + ", " + _toDisplayString(hub.zipCode) + " " + _toDisplayString(hub.city) + ", " + _toDisplayString(hub.countryName), 1),
            _createElementVNode("dd", _hoisted_4, [
              (isSelectable(hub))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "c-magic-line c-magic-line--underline",
                    onClick: ($event: any) => (select(hub))
                  }, _toDisplayString(__props.selectLabel), 9, _hoisted_5))
                : (isSelected(hub))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.selectedLabel), 1))
                  : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-open", "heading"]))
}
}

})